export default {"src":"kbwebsite/assets/_next/static/media/phone.2d70cc58.svg","height":24,"width":24};